import { useContext } from 'react';

import { PortalContext } from '../Portal';

import { useIsInsideContainer } from './useIsInsideContainer';

/**
 * Хук для поиска первого родительского scroll-элемента снаружи контейнера SDK.
 *
 * @returns Найденный элемент внутри shadow DOM или null, если элемент не найден.
 */

export const useSearchSdkOutsideParentNode = () => {
  const isInsideContainer = useIsInsideContainer();
  const portalContext = useContext(PortalContext);

  if (!isInsideContainer) return null;

  const rootId = portalContext?.widgetContainerId;
  const shadowRootWrapper = (rootId && document.getElementById(rootId)) || null;

  if (!shadowRootWrapper) return null;

  let node: Element | null = shadowRootWrapper;

  while (node) {
    const style = window.getComputedStyle(node);
    const scrollable =
      style.overflowY === 'auto' || style.overflowY === 'scroll';

    if (scrollable) return node;

    node = node.parentElement;
  }

  return null;
};
